/**
 * Stable tab identifiers for the native bottom-nav tab stacks. Each value owns one kept-alive
 * pane; a route is mapped to one of these (or a `seg:<segment>` fallback) by `resolveTabId`.
 */
export const TAB_ID = {
  HOME: 'home',
  PIPELINES: 'pipelines',
  PRICING: 'pricing',
  COMMS: 'comms',
  PHONE: 'phone',
};

/**
 * Path prefixes that map onto a bottom-nav tab. A pathname equal to `prefix` or starting with
 * `${prefix}/` belongs to that tab's stack. Order is not significant (prefixes are disjoint).
 */
export const TAB_PREFIX_RULES = [
  { prefix: '/pipelines', tabId: TAB_ID.PIPELINES },
  { prefix: '/dashboards', tabId: TAB_ID.HOME },
  { prefix: '/report-builders', tabId: TAB_ID.HOME },
  { prefix: '/pricing-workbench', tabId: TAB_ID.PRICING },
  { prefix: '/messages', tabId: TAB_ID.COMMS },
  { prefix: '/phone', tabId: TAB_ID.PHONE },
];

/**
 * Deep destinations that have no tab prefix of their own and must stay in the stack of whichever
 * tab opened them (the loan editor is reached from the Pipelines list, Home, etc.). They stick to
 * the currently-active tab rather than spawning their own pane.
 */
export const STICKY_PREFIXES = ['/loans', '/applications'];

/** Tab a sticky deep path falls back to on a cold deep-link (no active tab yet). */
export const DEFAULT_STICKY_TAB_ID = TAB_ID.PIPELINES;

/** Tab used for the home route and as the ultimate fallback. */
export const DEFAULT_TAB_ID = TAB_ID.HOME;
